import React, { useState, useEffect, useContext } from 'react';
import { Typography, Checkbox, Flex, Spin, theme } from 'antd';
import _ from 'lodash';

import { MessageContext } from '../../../layouts/NavigationLayout';
import SaveButton from './Buttons/SaveButton';

const { Title, Text } = Typography;
const { useToken } = theme;

const ImportantNotesView = (props) => {
	const [acknowledge, setAcknowledge] = useState(false);
	const messageApi = useContext(MessageContext);
	const { token } = useToken();
	const { colorPrimary } = token;
	const { importantNotePageProps, onImportantNotesViewSubmit, resetImportantNotesMeta, getEvent, reviewAndSubmissionPageProps, setHasUnsavedChanges } = props;
	const { meta, loading, loadingSubmit, event } = importantNotePageProps;
	const { application } = reviewAndSubmissionPageProps;
	const { application_end_date_string, offer_date_string } = event || {};
	console.log('application_end_date_string:', application_end_date_string);

	// Functions
	const onSubmit = () => {
		onImportantNotesViewSubmit();
	};

	useEffect(() => {
		getEvent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!_.isNil(application) && !_.isEmpty(application)) {
			setAcknowledge(true);
			setHasUnsavedChanges(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [application]);

	useEffect(() => {
		if (meta) {
			if (meta.code !== 200) {
				messageApi.open({
					type: 'error',
					content: `${meta.message}`,
					duration: 2.5
				});
			}
		}

		return () => resetImportantNotesMeta();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	const onChange = (e) => {
		setAcknowledge(e.target.checked);
	};

	if (loading) {
		return (
			<div
				style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
			>
				<Spin />
			</div>
		);
	}

	return (
		<div style={{ width: '96%' }}>
			<Title
				level={2}
				style={{ color: colorPrimary }}
			>Step 1</Title>
			<Text
				strong
				style={{ fontSize: '20px' }}
			>Important Notes
			</Text>
			<div style={{ marginTop: 18, fontSize: '14px', lineHeight: '22px' }}>
				<Text>Please read the application guidelines and important notes before completing the online application form.</Text>

				<div style={{ marginTop: 18 }}>
					<Text style={{ fontWeight: 650 }}>Important Notes</Text>
					<ul style={{ marginTop: 15 }}>
						<li style={{ marginBottom: 18 }}>This online application form should be completed by the applicant and must be
							submitted to the HKUST Office of the Dean of Engineering (Research and Graduate Studies) (DENG RPG) by <b>23:59 on {application_end_date_string} (GMT+8)</b>.
							No changes can be made after submission.
						</li>
						<li style={{ marginBottom: 18 }}>
							Please read the
							<a
								href="https://seng.hkust.edu.hk/academics/research-postgraduate/summer-camp/application-guidelines"
								target="_blank"
								rel="noreferrer"
							> <u>application guidelines</u> </a>
							and important notes before completing the online application form.
						</li>
						<li style={{ marginBottom: 18 }}>
							The application form must be completed in English.
						</li>
						<li style={{ marginBottom: 18 }}>
							All submitted documents or information will not be returned to the applicants.
						</li>
						<li style={{ marginBottom: 18 }}>
							You may check your application status via this online application system after submitting your application. Please allow 3 working days for the organizer to update the status in the system.
						</li>
						<li style={{ marginBottom: 18 }}>
							DENG RPG will send a letter of acceptance to the shortlisted applicants via email by {offer_date_string} (GMT+8). Please check your spam or junk email box regularly. Important messages, including updates and notifications, may sometimes be filtered there.
						</li>
						<li style={{ marginBottom: 18 }}>
							All information submitted will be kept strictly confidential and will only be used by the Hong Kong University of Science and Technology (HKUST)
							and viewed by the School of Engineering and its departments for the purpose of selection.
						</li>
						<li style={{ marginBottom: 18 }}>
							In compliance with the requirements of the Personal Data (Privacy) Ordinance of Hong Kong, HKUST has formulated a
							<a
								href="https://dataprivacy.hkust.edu.hk/university-data-privacy-policy-statement"
								target="_blank"
								rel="noreferrer"
							> <u>University Data Privacy Policy Statement</u> </a>
							to ensure compliance by staff and agents in handling the submitted personal information with the strictest standards of security and confidentiality.
						</li>
						<li style={{ marginBottom: 35 }}>
							In addition to the Personal Information Collection Statement (PICS) stated in "Step 7: Review & Submission", applicant who is residing and located in the Chinese Mainland, please also read carefully the PRC (People's Republic of China) Addendum before submitting the online application.
						</li>

						<li style={{ listStyleType: 'none', marginLeft: -20 }}>
							<div>
								<Checkbox
									checked={!_.isEmpty(application) || acknowledge}
									disabled={!_.isEmpty(application)}
									onChange={onChange}
									style={{ fontSize: '16px' }}
								>
								</Checkbox>
								<span style={{ marginLeft: 15, fontWeight: 510 }}>I acknowledge that I have read and understood the important notes.</span>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div style={{ marginTop: 26 }}>
				<Flex justify="end">
					<SaveButton
						label={_.isNil(application) || _.isEmpty(application) ? 'Start Application' : 'Next'}
						onClick={onSubmit}
						disabled={!acknowledge}
						loading={loadingSubmit}
					/>
				</Flex>
			</div>
		</div>
	);
};

export default ImportantNotesView;